import { render, staticRenderFns } from "./PageDivider.vue?vue&type=template&id=65d27d48&scoped=true&"
import script from "./PageDivider.vue?vue&type=script&lang=js&"
export * from "./PageDivider.vue?vue&type=script&lang=js&"
import style0 from "./PageDivider.vue?vue&type=style&index=0&id=65d27d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d27d48",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PageDivider.vue
// module id = 240
// module chunks = 0